import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const DeleteClusterModal = ({ 
    visible, 
    onClose, 
    onConfirm, 
    loading, 
    clusterData,
    isRTL,
    dmode 
}) => {
    const { t } = useTranslation();
    return (
        <Modal
            title={
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    fontFamily: 'Mulish, sans-serif',
                    fontWeight: '700',
                    color: dmode ? '#ccc' : '#333333'
                }}>
                    <ExclamationCircleOutlined style={{ color: '#FF4D4F', fontSize: '18px' }} />
                    {t('DELETE_CLUSTER')}
                </div>
            }
            open={visible}
            onCancel={onClose}
            centered
            width={450}
            footer={null}
            maskClosable={!loading}
            closable={!loading}
            bodyStyle={{ 
                padding: '24px',
                fontFamily: 'Mulish, sans-serif',
                backgroundColor: dmode ? '#2f353e' : '#fff'
            }}
            style={{
                direction: isRTL ? 'rtl' : 'ltr'
            }}
            styles={{
                header: {
                    backgroundColor: dmode ? '#2f353e' : '#fff',
                    borderBottom: 'none'
                },
                body: {
                    backgroundColor: dmode ? '#2f353e' : '#fff'
                },
                content: {
                    backgroundColor: dmode ? '#2f353e' : '#fff'
                }
            }}
        >
            <div style={{ marginBottom: '24px' }}>
                <p style={{ 
                    fontSize: '14px', 
                    color: dmode ? '#999' : '#666666', 
                    marginBottom: '16px',
                    lineHeight: '1.5'
                }}>
                    {t('ARE_YOU_SURE_DELETE_CLUSTER')}
                </p>
                
                {clusterData && (
                    <div style={{
                        backgroundColor: dmode ? '#3a4149' : '#F8F9FA',
                        padding: '16px',
                        borderRadius: '8px',
                        border: dmode ? '1px solid #555' : '1px solid #E9ECEF'
                    }}>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: '600', color: dmode ? '#ccc' : '#333333' }}>{t('CLUSTER_NAME')}: </span>
                            <span style={{ color: dmode ? '#999' : '#666666' }}>{clusterData.clusterName}</span>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: '600', color: dmode ? '#ccc' : '#333333' }}>{t('CODE')}: </span>
                            <span style={{ color: dmode ? '#999' : '#666666' }}>{clusterData.code || clusterData.clusterCode}</span>
                        </div>
                    </div>
                )}
            </div>

            <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-end', 
                gap: '12px'
            }}>
                <Button
                    onClick={onClose}
                    disabled={loading}
                    style={{
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600',
                        height: '36px',
                        minWidth: '80px',
                        backgroundColor: dmode ? '#3a4149' : '#fff',
                        borderColor: dmode ? '#555' : '#d9d9d9',
                        color: dmode ? '#ccc' : '#333'
                    }}
                >
                    {t('CANCEL')}
                </Button>
                <Button
                    type="primary"
                    danger
                    onClick={onConfirm}
                    loading={loading}
                    icon={!loading ? <DeleteOutlined /> : null}
                    style={{
                        backgroundColor: '#FF4D4F',
                        borderColor: '#FF4D4F',
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600',
                        height: '36px',
                        minWidth: '120px'
                    }}
                >
                    {loading ? t('DELETING') : t('DELETE')}
                </Button>
            </div>
        </Modal>
    );
};

export default DeleteClusterModal;